import { IAction } from "../action";
import { actionTypes } from "../actions";
var initialState = {
    isReportOptionsOpen: true,
};
export function reportOptions(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.expandReportOptions:
            return {
                isReportOptionsOpen: !state.isReportOptionsOpen,
            };
        default:
            return state;
    }
}
